import { useRef, useCallback, useEffect, useState } from 'react';

export default function useTriggerRecognition(responseText) {
  const utteranceRef = useRef(null);
  const [voices, setVoices] = useState([]);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isLoadingSpeech, setIsLoadingSpeech] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [canPause, setCanPause] = useState(false);

  useEffect(() => {
    const loadVoices = () => {
      const allVoices = window.speechSynthesis.getVoices();
      setVoices(allVoices);
    };

    loadVoices();
    window.speechSynthesis.onvoiceschanged = loadVoices;

    return () => {
      window.speechSynthesis.onvoiceschanged = null;
    };
  }, []);

  const read = useCallback(() => {
    console.log("[Button] Read clicked");

    if (!responseText || typeof responseText !== 'string') return;

    window.speechSynthesis.cancel();
    setIsSpeaking(true);
    setIsLoadingSpeech(true);
    setIsPaused(false);
    setCanPause(false);

    const utterance = new SpeechSynthesisUtterance(responseText.trim());

    const voiceUK = voices.find(v => v.name === "Microsoft Sonia Online (Natural) - English (United Kingdom)");
    if (voiceUK) {
      utterance.voice = voiceUK;
    }

    utterance.onstart = () => {
      console.log("[Speech] Started");
      setIsLoadingSpeech(false);
      setIsSpeaking(true);
      setCanPause(true);
    };

    utterance.onend = () => {
      console.log("[Speech] Finished");
      setIsSpeaking(false);
      setIsPaused(false);
      setCanPause(false);
      setIsLoadingSpeech(false);
    };

    utteranceRef.current = utterance;
    window.speechSynthesis.speak(utterance);
  }, [responseText, voices]);

  const pause = useCallback(() => {
    console.log("[Button] Stop clicked");
    if (isSpeaking) {
      window.speechSynthesis.cancel();
      setIsPaused(true);
      setIsSpeaking(false);
      setCanPause(false);
    }
  }, [isSpeaking]);

  return { read, pause, isSpeaking, isLoadingSpeech, isPaused, canPause };
}
